<div class="background">
    <app-website-header></app-website-header>
    <app-carousel></app-carousel>
    <div class="home">
      <img src="../../assets/images/icons/home-icon.svg" alt="" [routerLink]="['/']">
      <div [routerLink]="['/']">Home</div>
      <div [routerLink]="['/']">/ News & Insights</div>
    </div>
  
    <div class="heading-with-line">
      <div class="line1"></div>
      <div class="heading-text" style="font-weight: 600;font-size:18; font-family: 'Georgia' !important;">News & Insights</div>
      <div class="line2"></div>
    </div>
    <div class="card-container">
      <div class="card" (click)="navigateToNews()">
        <img src="../../../../assets/images/LatestNews.jpg" alt="latestNews-img">
        <p>Latest News</p>
      </div>
      <div class="card" (click)="navigateToEvents()">
        <img src="../../../../assets/images/Events.jpg" alt="events-img">
        <p>Events</p>
      </div>
    
    </div>
    <app-website-footer></app-website-footer>
  </div>
